import React from 'react';
import { Link } from 'react-router-dom';
import { API_BASE } from '../api/api';
import './PostCard.css';

const PostCard = ({ post }) => {
  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    const d = new Date(dateStr);
    return d.toLocaleDateString('tr-TR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });
  };

  const coverUrl = post.coverImageUrl
    ? (post.coverImageUrl.startsWith('http') ? post.coverImageUrl : `${API_BASE}${post.coverImageUrl}`)
    : null;

  return (
    <Link to={`/post/${post.slug}`} className="post-card-link">
      <article className="post-card">
        <div className="card-tape" />

        <div className="card-meta">
          <span className="card-category">{post.category?.toLowerCase()}</span>
          <span className="card-date">{formatDate(post.publishedDate)}</span>
        </div>

        <h2 className="card-title">{post.title}</h2>

        {coverUrl && (
          <div className="card-image-wrapper">
            <img src={coverUrl} alt={post.title} className="card-image" loading="lazy" />
          </div>
        )}

        {post.excerpt && (
          <p className="card-excerpt">{post.excerpt}</p>
        )}

        {post.tags && post.tags.length > 0 && (
          <div className="card-tags">
            {post.tags.map(tag => (
              <span key={tag} className="card-tag">{tag}</span>
            ))}
          </div>
        )}
      </article>
    </Link>
  );
};

export default PostCard;
